import React from "react";
import SVGInline from "react-svg-inline";

/* eslint import/no-webpack-loader-syntax: off */
import svg from "!raw-loader!../../images/icons/close-icon.svg";

export default ({ height = "20px", pointer = true, onClick }) => (
  <SVGInline
    height={"20px"}
    svg={svg}
    onClick={onClick ? onClick : () => {}}
    className={pointer ? "pointer" : ""}
  />
);



// WEBPACK FOOTER //
// ./src/components/icons/CloseIcon.js